var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoiceServices = function SvgInvoiceServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.706 1H4.222A3.223 3.223 0 0 0 1 4.223v33.554A3.223 3.223 0 0 0 4.222 41h22.484a3.22 3.22 0 0 0 3.222-3.223V4.223A3.223 3.223 0 0 0 26.706 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M33.028 35.612c0 1.034.049 2.042 0 3.026C32.954 40.016 31.822 41 30.37 41h-24.5c1.18-1.697.615-3.567.811-5.388h26.37zM17.654 24.296H4.567M17.654 20.237H4.567M17.654 28.479H4.567M5.723 11.898c0 1.008.787 1.82 1.747 1.82h1.968c.836 0 1.525-.713 1.525-1.599 0-.96-.418-1.304-1.033-1.525L6.78 9.487c-.614-.221-1.032-.541-1.032-1.525 0-.886.689-1.6 1.525-1.6H9.24c.96 0 1.746.812 1.746 1.821M8.33 5.379v9.397M21.59 19.967l.811.812 1.747-1.6M21.59 28.11l.811.811 1.747-1.599M21.59 24.026l.811.812 1.747-1.6"
  })));
};
export default SvgInvoiceServices;